"use client";

import React from "react";
import { SupLoader } from "@repo/core-ui";

export default function LoaderFullSize() {
  return (
    <div className="flex flex-1 items-center justify-center">
      <SupLoader className="max-h-16" />
    </div>
  );
}
